import dayjs from "dayjs";
import { formatNumber } from "./commonFunction";

// Raw-count multipliers for the entitlement units whose size is unambiguous. A
// discount_value is a raw usage count, not a quantity in the entitlement's unit.
const UNIT_MULTIPLIERS = {
    million: 1e6,
    billion: 1e9,
};

// Mirrors client-mgmt: only sub entitlements are metered, so only they take discounts.
function isSubEntitlement(entitlement) {
    return !!(entitlement && entitlement.base_entitlement_id);
}

// "aIOBulkPut (UsageEntitlements-c008)" - sub entitlement names repeat across base
// entitlements, so the base name is what tells them apart.
function subEntitlementLabel(entitlement, entitlementsById) {
    if (!entitlement) return "";
    const base = entitlementsById[entitlement.base_entitlement_id];
    return base ? `${entitlement.name} (${base.name})` : entitlement.name;
}

function formatDiscount(discount) {
    if (discount.discount_percentage != null) {
        return `${formatNumber(discount.discount_percentage)}% off`;
    }
    if (discount.discount_value != null) {
        return `${formatNumber(discount.discount_value)} free / month`;
    }
    return "";
}

// effective_date and end_date are both inclusive YYYY-MM-DD strings.
function discountStatus(discount, today = dayjs().format("YYYY-MM-DD")) {
    if (discount.effective_date > today) return "Scheduled";
    if (discount.end_date < today) return "Expired";
    return "Active";
}

// The usage count expressed in the entitlement's unit, e.g. 6,000,000,000 -> "6,000 million",
// or null when the unit has no fixed size.
function usageInUnit(value, unit) {
    const multiplier = UNIT_MULTIPLIERS[unit];
    if (!multiplier || !(value > 0)) return null;
    return `${formatNumber(value / multiplier)} ${unit}`;
}

// client-mgmt rejects a discount whose dates overlap another one of the client's on the
// same entitlement; finding it here lets the form name the clashing discount.
function findOverlappingDiscount(discount, discounts) {
    return discounts.find((other) =>
        other.discount_id !== discount.discount_id &&
        other.entitlement_id === discount.entitlement_id &&
        other.effective_date <= discount.end_date &&
        other.end_date >= discount.effective_date
    );
}

export {
    isSubEntitlement,
    subEntitlementLabel,
    formatDiscount,
    discountStatus,
    usageInUnit,
    findOverlappingDiscount,
};
